<template>
  <article class="info_table">
    <modal-pass @cancel="onCancel" @activate="onActivate" v-if="showModal"/>
    <modal-export @cancel="onCancelExport" @activate="onActivateExport" v-if="modalExportActive"/>
    <modal-export-schedule @cancel="isActiveDownload=false" @export="isActiveDownload=false" :dates="myDownloadDates" v-if="isActiveDownload"></modal-export-schedule>
    <modal-rectify  @cancel="onCancelRectify" @activate="onActivateRectify" v-if="modalRectifyActive" :turno="seleccionado"></modal-rectify>
    <a id="anchor"> </a>
    <div class="info_table__head">
        <h2 v-show="name">Listado de {{name}}</h2>
        <div v-show="name" class="search_input">
          <input  type="text" id="myInput" @input="search()" placeholder="Buscar...">
          <img src="./../../assets/img/icons/search.svg">
        </div>

      </div>      
    <table id="myTable">
      
      <tr class="info_table__header">
        <th  v-for="(column,i) in columns" :key=i>
          <div :class="{'active': isSorted}" @click=" column.name=='ID'? itemsbefore.sort(compare) : isSorted=false;" v-if="column.name == 'Acciones' ? isAdmin: true" >
            {{column.name}}
            <img v-if="column.sortable" src="./../../assets/img/icons/arrow.svg">
          </div>
        </th>
      </tr>
      <tr v-for="(item,i) in itemsPage" :key=i>
        <td v-if="('user' in item) && ('card_company' in item.user)">
          <div @click="name.includes('guardas')?$router.push({ path: '/guards/' + item.user.id_card}):$router.push({ path: routePath + '/' + item.user.id_card})" class="info_table--clickable" :class="{active:columns[0].clickable}">{{item.user.card_company}}</div>
        </td>


        <td v-if="name=='guardas sin reporte'" >         
          <input v-if="!item.check"  type="radio"  @click="numberOfRow(i)"  :id="'radio'+i" >          
        </td>
        <td v-if="('time' in item)" >         
          <div>{{item.time.date|stringDateYear}}</div>        
        </td>
         <td v-if="('time' in item)" >              
          <div>{{item.time.hour}}</div> 
        </td>



        <td v-if="('updated_at' in item)">
          <div>{{item.updated_at|stringDateAll}}</div>
        </td>
        <td v-if="'user' in item">
          <div>{{item.user.name |capitalizeName}} {{item.user.last_name|capitalizeName}}</div>
        </td>
        <td v-if="('name' in item)">

          <div @click="$router.push({ path: routePath + '/' + item.nit })"  class="info_table--clickable" :class="{active:columns[0].clickable}" >{{item.name}}</div>
        </td>
        <td  v-if="'city' in item">
          {{item.city}}
        </td>
        <td v-if="'nit' in item">
          {{item.nit}}
        </td>
        <td v-if="('imei' in item)">
          <div>{{item.imei}}</div>
          
        </td>
        <td v-if="('user' in item) && 'id_card' in item.user && !('extra_role' in item.user)">
          {{item.user.id_card}}          
        </td>
        
        <td v-if="('device' in item)">
          <div class="info_table--hover">{{item.device.number}}
            <span>
              <p>{{item.device.company}}</p>
              {{item.device.location}}
            </span>
          </div>
        </td>
        <td v-if="'devices' in item">
          {{item.devices.number}}          
        </td>
        <td v-if="'devices' in item">
          <div @click="item.schedule?openDownloadModal(item):null" :style="item.schedule?'color:#4553CE;cursor:s-resize':'color:black;cursor:not-allowed'"  class="info_table--hover info_table--clickable" :class="{active:true}">
            {{item.schedule?"Descargar":"No disponible"}}
            <span v-if="item.schedule">
                Descargar programación              
            </span>
          </div>
        </td>
        <td v-if="'location' in item">
          <div class="info_table--clickable active" :style="item.identifier==null?'cursor:not-allowed':''"  @click="item.identifier!=null?$router.push({ path: routePath + '/' + item.identifier }):null" >{{item.location}}</div>
        </td>
        <td v-if="('number' in item)">
          <div class="info_table--hover">{{item.number}}
            <span>
              <p>{{item.company}}</p>
              {{item.location}}
            </span>
          </div>
        </td>
        
        <td v-if="('user' in item) && ('extra_role' in item.user)">
          {{item.user.extra_role?'Administrador':'Operario de '+item.user.department}}
        </td>
        <td :style="{'display':'flex', 'padding-top':'13px'}" v-if="'is_working' in item" >          
          <div :class="{'active': item.is_working && (name=='guardas' || (name.includes('guardas en') && name.split('guardas en')[1].includes(item.device.location)))}" class="status_icon"></div>
            {{item.is_working && (name=="guardas" ||  (name.includes('guardas en') && name.split('guardas en')[1].includes(item.device.location))) ? 'Activo': 'Inactivo'}}
          </td>

        <td v-if="actions && (getRol() == 'admin' || getRol() == 'coord') || name=='guardas'" >
          <div class="info_table__actions"> 
            
              <div class="info_table--hover1" v-if="getRol() == 'admin' || getRol() == 'coord'">
                <img @click="edit(item)" src="./../../assets/img/icons/edit.svg">
                <span>Editar</span>
              </div>
              <div class="info_table--hover1" v-if="getRol() == 'admin' || getRol() == 'coord'">              
                <img @click="disable(i);" v-if="name=='guardas' && item.user.is_active" src="./../../assets/img/icons/guard.svg">            
                <img @click="disable(i);" v-if="name=='guardas' && !item.user.is_active" src="./../../assets/img/icons/guard_disable.svg">
                <span v-if="name=='guardas' && !item.user.is_active" style="align:center">Habilitar</span>
                <span v-if="name=='guardas' && item.user.is_active" style="align:center">Inhabilitar</span> 
              </div>
              <div class="info_table--hover1" v-if="getRol() == 'admin'"> 
                <img @click="disable(i);" v-if="name=='coordinadores' && item.user.is_active" src="./../../assets/img/icons/coord.svg">
                <img @click="disable(i);" v-if="name=='coordinadores' && !item.user.is_active" src="./../../assets/img/icons/guard_disable.svg">
                <span v-if="name=='coordinadores' && !item.user.is_active" style="align:center">Habilitar</span>
                <span v-if="name=='coordinadores' && item.user.is_active" style="align:center">Inhabilitar</span> 
              </div>
              <div class="info_table--hover1" v-if="getRol() == 'admin'">
                <img @click="disable(i);" v-if="name=='administradores' && !item.user.extra_role && item.user.is_active" src="./../../assets/img/icons/businessman.svg">
                <img @click="disable(i);" v-if="name=='administradores' && !item.user.extra_role && !item.user.is_active" src="./../../assets/img/icons/business_disable.svg">  
                <span v-if="name=='administradores' && !item.user.extra_role && !item.user.is_active">Habilitar</span>
                <span v-if="name=='administradores' && !item.user.extra_role && item.user.is_active" style="align:center">Inhabilitar</span> 
              </div>
              <div class="info_table--hover1" v-if="getRol() == 'admin'">
                <img @click="disable(i);" v-if="name=='clientes' && item.is_active" src="./../../assets/img/icons/client.svg">
                <img @click="disable(i);" v-if="name=='clientes' && !item.is_active" src="./../../assets/img/icons/manufacturer_disable.svg">
                <span v-if="name=='clientes' && !item.is_active">Habilitar</span>
                <span v-if="name=='clientes' && item.is_active" style="align:center">Inhabilitar</span> 
              </div>
              <div class="info_table--hover1" v-if="getRol() == 'admin'">       
                <img @click="disable(i);" v-if="name=='dispositivos' && item.is_active" src="./../../assets/img/icons/device.svg">
                <img @click="disable(i);" v-if="name=='dispositivos' && !item.is_active" src="./../../assets/img/icons/cell-phone-disabled.svg">
                <span v-if="name=='dispositivos' && item.is_active">Habilitar</span>
                <span v-if="name=='dispositivos' && item.is_active" style="align:center">Inhabilitar</span> 
              </div>
              <div class="info_table--hover1" v-if="getRol() == 'coord'">       
                <img @click="AssignToCompany(item)" v-if="name=='dispositivos' && item.device.company == 'Cliente Neiva PRUEBA'" src="./../../assets/img/icons/client.svg">
                <span v-if="name=='dispositivos' && item.device.company == 'Cliente Neiva PRUEBA'">Asignar a contrato</span>
              </div>
            <div class="info_table--hover1">       
              <img v-if="!(actualItem == i) && (name!='administradores') && (name!='dispositivos') && (name!='clientes')"  @click="passwordModal(i)" src="./../../assets/img/icons/lock.svg">
              <span style="width:80px;">Restablecer contraseña</span>
            </div>
            <div id="timer" v-if="actualItem == i && rightView && modalActivate && timerRunning" ></div>
          </div>
        </td>
      </tr>
      
    </table>
    <div class="info_table__foot" v-show="paginator">
      <div/>
      <div class="paginator">
        {{shownItemsFrom}} - {{shownItemsTo}} de {{activeFilter?dinamicData.length:itemsbefore.length}}
        <div class="paginator__numbers">
          <div v-for="(page,i) in totalPages" @click="paginate(maxPage*i, maxPage*(i+1),i+1)" :key=i class="paginator__numbers--num" :class="{'active': actualPage==i+1}">
            {{i+1}}
          </div>
          <div class="paginator__numbers--num" @click="paginate(maxPage*actualPage, maxPage*(actualPage+1), actualPage+1)">
            >
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import moment from 'moment';
export default {
  props:{
    name:{
      type: String,
      
    },
    columns:{
      type: Array,
      required:true
    },
    items:{
      type: Array,
      required:true
    },
    actions:{
      type:Boolean,
      required:true

    },
    paginator: false
    
  },
  data() {
    return{
      itemsbefore:[],
      meses:{
        "01":"ENERO",
        "02":"FEBRERO",
        "03":"MARZO",
        "04":"ABRIL",
        "05":"MAYO",
        "06":"JUNIO",
        "07":"JULIO",
        "08":"AGOSTO",
        "09":"SEPTIEMBRE",
        "10":"OCTUBRE",
        "11":"NOVIEMBRE",
        "12":"DICIEMBRE"
        },
        

     
      lastClient:"",
      turnsByClient: [],
      itemsPage: [],
      routePath: this.$route.path,
      showModal: false,
      modalActivate: false,
      actualItem: null,

      modalExportActive: false,
      modalRectifyActive:false,
      isActiveDownload:false,
      myDownloadDates:[],
      timerRunning:false,
      maxPage:12,
      actualPage:1,
      totalPages:1,
      shownItemsFrom:0,
      shownItemsTo: 12,
      isSorted: false,
      isAdmin:(localStorage.getItem('isAdmin') == 'true'),
      headersCSV:{
        start_date:"FECHA DE INICIO",
        start_hour:"HORA DE INICIO", 
        end_date:"FECHA DE SALIDA",
        end_hour:"HORA DE SALIDA",
        location_device: "UBICACION DEL DISPOSITIVO",   
        guard:"NOMBRE DEL GUARDA",
        guardDocument:"DOCUMENTO",
        number_device: "NUMERO DEL DISPOSITIVO",
        is_diurnal:"HORARIO",    
        reports: "NUMERO DE REPORTES EN TURNO",          
        id:"NUMERO DE TURNO", 

      },
      headersGuards:{
        name: "NOMBRE GUARDA",
        id:"DOCUMENTO",
        least4:"TURNOS MENORES A 4 HORAS",
        least8:"TURNOS DE 4 A 8 HORAS",
        greaterThan8:"TURNOS DE 8 A 11 HORAS",
        greaterThan12:"TURNOS DE 12 O MÁS HORAS",
        withoutEnd:"TURNOS SIN FINALIZAR",
        strangeTurn:"TURNOS PARA REVISAR",
        reportsTurn:"REPORTES MES GUARDA"
      },
      dinamicData:[],
      activeFilter:false,
      //guardIcon: require('https://s3-us-west-2.amazonaws.com/laos-control-turnos/backoffice/ico_guard.svg')

    }
    
  },
  methods:{
    numberOfRow(row){   
      
      this.seleccionado=this.itemsPage[row];
      this.modalRectifyActive=true;
      document.getElementById("radio"+row).checked=false;
      
    },

    openDownloadModal(item){
      this.myDownloadDates=item.schedule.sort();
      this.isActiveDownload=true;
    },
    exportCronogram(url){

    },
    processTurns(datos){
      var processedData=[];     
      for(var i=0; i<datos.length;i++){
        var serviceItem={
        start_date:datos[i].start_date,
        start_hour:datos[i].start_hour,
        end_date:datos[i].end_date,
        end_hour:datos[i].end_hour,  
        location_device: datos[i].device.location,
        guard:datos[i].guard.name + " "+ datos[i].guard.last_name,
        guardDocument:datos[i].guard.id_card,          
        number_device: datos[i].device.number,
        is_diurnal:datos[i].is_diurnal, 
        reports:datos[i].reports,
        id:datos[i].id, 
        } 
        processedData.push(serviceItem);
      }
      return processedData;
    },
    processGuards(datos){
      var processedData=[];   
      var keys=Object.keys(datos);
               
      for(var i=0; i<keys.length;i++){  
        var num=keys[i]  
        var serviceItem={
        name:datos[keys[i]].name,
        id:keys[i],
        least4:datos[keys[i]].men,
        least8:datos[keys[i]].min,
        greaterThan8:datos[keys[i]].mid,
        greaterThan12:datos[keys[i]].may,
        withoutEnd:datos[keys[i]].sf,
        strangeTurn:datos[keys[i]].err,
        reportsTurn:datos[keys[i]].report,      
        }
        processedData.push(serviceItem);
      }
      return processedData;
    },
    /**
     * Método para convertir un objeto JSON a formato de tabla CSV.
     * Recibe como parametro el objeto
     * Retorna un String ya con el formato adecuado.
     * 
     */
    convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'sep=,\r\n';

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != '') line += ','
                if(array[i][index]===true ){
                  line += "Diurno";                              
                }else if(array[i][index]===false){
                  line += "Nocturno";    
                }else if(array[i][index]===null){
                  line += "No se ha terminado";  
                }else{
                  line += array[i][index];
                }
                
                
            }
            str += line + '\r\n';
        }        
        return str;
    },

    /**
     * Método para expotar los datos de los servicios a un archivo CSV
     * Recibe como parametro:
     *  una lista 'headers' con los títulos de las columnas.
     *  una lista 'list' con todos los servicios entregados.
     *  una lista 'list2' con todos los servicios devueltos.
     *  un string 'fileTitle' con el nombre del archivo a exportar. 
     * 
     * 
     */
    exportCSVFile(headers,headers_Guardias, list,list2,fileTitle) {  
      var listOne = this.processTurns(list);
      var listTwo = this.processGuards(list2);
     

      //Las une junto con los nombres de las columnas tod en un objeto JSON.
      var itemsbefore =  JSON.parse(JSON.stringify(listTwo.concat('\r\n').concat(headers).concat(listOne)));
      if (headers_Guardias) {
          itemsbefore.unshift(headers_Guardias);
          itemsbefore.unshift(["RESUMEN MENSUAL DE "+this.meses[this.lastMonth] + " "+this.lastClient.toUpperCase()+"\r\n"]);
      }

        
        var jsonObject = JSON.stringify(itemsbefore);
        
        // Convierte este objeto JSON a formato CSV
        var csv = this.convertToCSV(jsonObject);

        var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

        //Asigna al boton el atributo para que sea posible descargar el archivo.

        var blob = new Blob([csv], { type: 'text/csv;charset=UTF-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.getElementById("anchor");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                //link.style.visibility = 'hidden';
                //document.body.appendChild(link);
                link.click();
                //document.body.removeChild(link);
            }
        }
    },
    onCancel(value){
      this.showModal = value;
      this.actualItem = null;
      this.modalActivate = false;
    },
    onCancelExport(value){
      this.modalExportActive=false;      
    },
    onCancelRectify(value){
        this.modalRectifyActive=false;
    },

    onActivate(value){
      //Metódo para restablecer contraseña de un guarda haciendo petición la backend.
      const customActions={
        changePassword: {headers:{"Authorization" : 'Bearer '+ localStorage.getItem('crypto')},method: 'DELETE'}                   
      };
      if(this.name == 'guardas'){
        
        this.resource= this.$resource('guards/dashboard/' + this.itemsPage[this.actualItem].user.id_card,{},customActions);
        
      }else if(this.name == 'coordinadores'){

        this.resource= this.$resource('coordinators/dashboard/' + this.itemsPage[this.actualItem].user.id_card,{},customActions);
      }
      this.resource.changePassword().then(function(data){

        });

      this.date = moment(60*1000);
      this.initTimer();
    },
    onActivateExport(value){
      this.modalExportActive=false;
      const customActions={
          get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      this.lastMonth=value.split("-")[1];
      this.$resource('company_devices',{},customActions).get({nit:this.lastClientNit, date:value})
      .then(function(data){       
        console.log(data); 
        this.turnsByClient=data.body.turns;
        this.turnsByGuard=data.body.guards;
        this.exportCSVFile(this.headersCSV,this.headersGuards,this.turnsByClient,this.turnsByGuard,this.lastClient+"_"+value);
        //console.log(data.body[0].user);
      });
    },
    onActivateRectify(value){   
      
      
      const customActions={
      patch: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'}                   
      };
      var card=JSON.parse(localStorage.getItem("user")).id_card;       
      this.$resource('administrators/reports/'+value[0].id,{},customActions).patch({"value":value[1],"id_card":card, comments: value[2], whoreviews: value[3]})
      .then(function(data){
         this.itemsbefore=data.body;        
         this.modalRectifyActive=false;  
         this.activeFilter=false;
         this.$emit('checked',data.body);
         this.activeFilter=true;
         console.log('Justificación: ',value)
      });
      
      
    },

    disable(index){

      //Metódo que deshabilita un usuario


      const customActions={
        disableUser: {headers:{"Authorization" : 'Bearer '+ localStorage.getItem('crypto')},method: 'DELETE'}                   
      };

      if(this.name == 'guardas'){
        
        this.resource= this.$resource('guards/access/' + this.itemsPage[index].user.id_card,{},customActions);
        
      }else if(this.name == 'coordinadores'){

        this.resource= this.$resource('coordinators/access/' + this.itemsPage[index].user.id_card,{},customActions);
      }else if(this.name == 'administradores'){

        this.resource= this.$resource('administrators/access/' + this.itemsPage[index].user.id_card,{},customActions);
      }else if(this.name == 'dispositivos'){

        this.resource= this.$resource('device/access/' + this.itemsPage[index].device.number,{},customActions);
      }else if(this.name == 'clientes'){
        this.resource= this.$resource('company/access/' + this.itemsPage[index].nit,{},customActions);
      }
      

      this.resource.disableUser().then(function(data){
        if(this.name == 'dispositivos'){
          this.itemsPage[index].is_active=!this.itemsPage[index].is_active;
        }else if(this.name == 'clientes'){
          this.itemsPage[index].is_active=!this.itemsPage[index].is_active;
        }else{
          this.itemsPage[index].user.is_active=!this.itemsPage[index].user.is_active;
        }
        
      });
    },

    initTimer(){

      //Método para iniciar el temporizador de restablecimiento de contraseña.

      this.showModal = false;
      this.modalActivate = true;
      this.timerRunning = true;
      var tempObj = JSON.parse(localStorage.getItem('timesRunning'));
      tempObj.item = this.actualItem;
      //temp[this.actualItem] = moment().format('hh:mm:ss');
      tempObj["view"] = this.$route.name;
      tempObj.isRunning = true;
      localStorage.setItem('timesRunning', JSON.stringify(tempObj));
      
      var temp = this.actualItem;
      

      //Crea un intevarlo con duración de 1 minuto y lo muetra en la tabla

      var timer =  setInterval(() => {
        //console.log(this.date);
        //console.log(this.actualItem);
        
        if(this.date>0 && (temp==this.actualItem)){
          //this.date.subtract(1, 'seconds');
          //this.date = moment(4*1000);
          
          if(tempObj.view == this.$route.name){
            document.getElementById('timer').innerHTML = this.date.format('mm:ss');
          }
          this.date = moment(this.date._i -1000);
          
          
          
        }else{



          clearInterval(timer);
          //document.getElementById('timer').style="display:none";
          tempObj.isRunning= false;
          tempObj.item =null;
          this.modalActivate = false;
          this.actualItem = null;
          this.timerRunning = false;
          if(tempObj.view == this.$route.name){
            document.getElementById('timer').innerHTML = '';
          }
          localStorage.setItem('timesRunning',JSON.stringify(tempObj));
          
        }
        
      }, 1000);

    },
    passwordModal(index){
      var running = JSON.parse(localStorage.getItem('timesRunning'));

      //Si el tiempo no está corriendo permite activar el modal y restablecer la contraseña.

      if(!running.isRunning){
        this.modalActivate = false;
        this.showModal = true;
        this.actualItem = index;
      }else{
        //alert('H')
      }
    },
    exportModal(value){
      this.lastClientNit=value.nit;
      this.lastClient=value.name;
      this.modalExportActive = true;

    },
    search(){

      console.log('--------------->>>>busqueda')

      //Método para buscar en la tabla por ID.
      
      // Declare variables 
      var input, filter, table, tr, tds, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toLowerCase();
      this.dinamicData=this.items;
      
      if(filter.length>0){
        this.activeFilter=true;
     
      }else{
       
        this.activeFilter=false;
      }
      
      var newItems=[]
      for(var element in this.activeFilter?this.dinamicData:this.itemsBefore){

        var myRow=JSON.stringify(this.dinamicData[element]).toLowerCase();
        if(myRow.indexOf(filter)>=0){
          newItems.push(this.dinamicData[element]);
        }

      }
      this.dinamicData=newItems;
      this.paginate(this.shownItemsFrom, this.maxPage,1);
      if(this.activeFilter){
          this.totalPages=Math.ceil((this.dinamicData.length/this.maxPage));
      }else{
        this.totalPages=Math.ceil((this.itemsbefore.length/this.maxPage));
      }
      // table = document.getElementById("myTable");
      // tr = table.getElementsByTagName("tr");
      // // Loop through all table rows, and hide those who don't match the search query
      // for (i = 1; i < tr.length; i++) {
      //   // if(this.name=='guardas sin reporte'){
      //   //   td = tr[i].getElementsByTagName("td")[2];
      //   // }else{
      //   //   td = tr[i].getElementsByTagName("td")[0];
      //   // }
      //   tds=tr[i].getElementsByTagName("td");
        
      //   var objectHTMLCollection =tds,
      //   string = [].map.call( objectHTMLCollection, function(node){
      //       return node.textContent || node.innerText || "";
      //   }).join("");
        
       
      //   if(string.replace( /[\r\n]+/gm, "" ).trim().toLowerCase().indexOf(filter.toLowerCase()) > -1) {
      //     tr[i].style.display = "";
      //   } else { 
      //     tr[i].style.display = "none";
      //   }  
        
      // }
    },
    paginate( i, j, page){
      
      // Paginación de la tabla diviendo la lista de items en una sublista desde un índice i a un índice j.
     
      if(j <= this.totalPages*this.maxPage){
        
        this.actualPage = page;
        if(this.activeFilter){
          this.itemsPage = this.dinamicData.slice(i,j);
          if(j>this.dinamicData.length){          
            this.shownItemsTo = this.dinamicData.length;
          }else{
            this.shownItemsTo = j;
          }
        }else{
          this.itemsPage = this.itemsbefore.slice(i,j);
          if(j>this.itemsbefore.length){
            
            this.shownItemsTo = this.itemsbefore.length;
          }else{
            this.shownItemsTo = j;
          }
        }
        this.shownItemsFrom = i;
       

      }

      console.log('estos son los guardas a mostrar ', this.itemsPage)
      
    },


    //Organiza los items por ID.
    sortId(){
      this.itemsbefore.sort(compare);
      this.isSorted=true;
    },
    compare(a ,b){
      if(a.user.card_company < b.user.card_company){
        return -1;
      }
      else if(a.user.card_company > b.user.card_company){
        return 1;
      }
      return 0;
    },



    getDate(dateString){
      return moment(dateString).format('MM/DD/YYYY hh:mm');
    },

    //Redirecciona a la vista editar de cada usuario.
    edit(item){
      if(this.name=='guardas'){
        this.$router.push({ path: 'editguard/' + item.user.id_card});
      }else if(this.name=='coordinadores'){
        this.$router.push({ path: 'editcoordinator/' + item.user.id_card });
      }else if(this.name=='administradores'){
        this.$router.push({ path: 'editadmin/' + item.user.id_card , query:{admin: item}});
      }else if(this.name=='clientes'){
        this.$router.push({ path: 'editclient/' + item.nit });
      }else if(this.name=='dispositivos'){
        this.$router.push({ path: 'editdevice/' + item.device.number});
      }
      
    },
    AssignToCompany(item){
      const customActions={
        AssignCompany: {headers:{"Authorization" : 'Bearer '+ localStorage.getItem('crypto')},method: 'POST'}                   
      };
      this.resource = this.$resource('device/assignCompany',{},customActions);
      this.resource.AssignCompany({
        Device: item.id
      }).then(function(data){
        console.log('OK');
        console.log(data);
        this.$router.push({ path: 'editdevice/' + item.device.number});
        
      }).catch(function(err){
        console.log('ERROR');
        console.log(err);
      });
      
      console.log(item)
    }
    
  },
  computed: {
    time: function(){
      return this.date.format('mm:ss');
    },
    rightView: function(){
      return JSON.parse(localStorage.getItem('timesRunning')).view == this.$route.name;
    },    

  },
  watch:{
    items: function(val){  
      this.itemsbefore=this.items; 
      this.dinamicData=this.items; 
      this.search();
    },
    itemsbefore: function(val){     
      if(this.shownItemsFrom==0){
        this.paginate(this.shownItemsFrom,this.maxPage,this.actualPage);
        if(this.activeFilter){
          this.totalPages=Math.ceil((this.dinamicData.length/this.maxPage));
        }else{
          this.totalPages=Math.ceil((this.itemsbefore.length/this.maxPage));
        }
      }else{
        this.paginate(this.shownItemsFrom,this.maxPage+(this.shownItemsFrom),this.actualPage);
        if(this.activeFilter){
          this.totalPages=Math.ceil((this.dinamicData.length/this.maxPage));
        }else{
          this.totalPages=Math.ceil((this.itemsbefore.length/this.maxPage));
        }
      }
         
    }
  },
  filters:{
    capitalizeName(str){
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();     
      }
      console.log(splitStr.join(' '))
      return splitStr.join(' '); 
    }
  },
  
  created(){     

    this.paginate(this.shownItemsFrom, this.maxPage,this.actualPage);
    var tempObj = null;
    //Si el timer continúa corrinedo lo muestra en la tabla
    if(localStorage.getItem('timesRunning')){
      tempObj = JSON.parse(localStorage.getItem('timesRunning'));
    }
    
    if(tempObj && tempObj.isRunning){

      if(tempObj.view==this.$route.name){
        this.actualItem = tempObj.item;
        this.modalActivate = true;
        this.timerRunning = true;
      }
      

    }else{
      this.timesRunning = {
        "item":null,
        "view":this.$route.name, 
        "isRunning": false
      };

      this.timerRunning = false;
      localStorage.setItem('timesRunning',JSON.stringify(this.timesRunning));

    }
    
    
  },
  beforeMount(){
    this.dinamicData=this.items;
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/Table.vue